// extracted by mini-css-extract-plugin
export default {"fsPriceRange":"price-range-module--fs-price-range--34d2f"};